module.exports = __webpack_public_path__ + "img/renovationBG2.5a1e91ce.png";